import { getGuessStatuses } from '../../lib/statuses'
import { MAX_WORD_LENGTH } from '../../constants/settings'
import { Cell } from './Cell'
import { unicodeSplit } from '../../lib/words'

type Props = {
  guess: string
  isRevealing?: boolean
}

export const CompletedRow = ({ guess, isRevealing }: Props) => {
  const statuses = getGuessStatuses(guess)
  const emptyCells = Array.from(Array(MAX_WORD_LENGTH - statuses.length))
  const splitGuess = unicodeSplit(guess)
  return (
    <div className="flex justify-center mb-1">
      {splitGuess.map((letter, i) => (
                <Cell
                key={i}
                value={letter}
                status={statuses[i]}
                position={i}
                isRevealing={isRevealing}
                isCompleted
                completedRowBool={true}
              />
      ))}
      {emptyCells.map((_, i) => (
        <Cell key={i} completedRowBool={true} emptyCellInCompleteRow={true} value={''} />
      ))}
    </div>
  )
}

